export const warehouseAdapter =
    ({
       id,
       title,
       address,
       type,
       branch_id,
       default_for_writeoff,
       default_for_sale
     }) => ({
      id: id ?? null,
      title: title ?? null,
      address: address ?? null,
      type: type ?? null,
      branch_id: branch_id ?? null,
      default_for_writeoff: default_for_writeoff ? 1 : 0,
      default_for_sale: default_for_sale ? 1 : 0
    })
